import { useMemo } from "react";

import { IntlShape } from "react-intl";

import Team from "@mapmycustomers/shared/types/Team";

import DataViewMode from "@app/enum/DataViewMode";

import messages from "../messages";
import { TeamDataRecord, UserDataRecord } from "../type/DataRecord";

import { NO_TEAM_ID } from "./const";
import sortByValue from "./sortByValue";

const useTeamChartData = (
  intl: IntlShape,
  userData: UserDataRecord[],
  selectedTeamIds: Set<Team["id"]>,
  dataMode: DataViewMode
) =>
  useMemo(() => {
    const teamDataMap: Record<number, TeamDataRecord> = {};
    const teamCount: Record<number, number> = {};
    userData.forEach((record) => {
      const user = record.entity;
      const value = record.value as number;
      if (user.teams.length) {
        user.teams.forEach((team) => {
          if (!teamDataMap[team.id]) {
            teamDataMap[team.id] = {
              entity: team,
              value: 0,
            };
            teamCount[team.id] = 0;
          }
          teamDataMap[team.id].value = teamDataMap[team.id].value + value;
          teamCount[team.id]++;
        });
      } else {
        if (!teamDataMap[NO_TEAM_ID]) {
          teamDataMap[NO_TEAM_ID] = {
            entity: { id: NO_TEAM_ID, name: "" },
            value: 0,
          };
          teamCount[NO_TEAM_ID] = 0;
        }
        teamDataMap[NO_TEAM_ID].value = teamDataMap[NO_TEAM_ID].value + value;
        teamCount[NO_TEAM_ID]++;
      }
    });
    const teamData = sortByValue(Object.values(teamDataMap)) as TeamDataRecord[];
    return teamData.map((record) => ({
      custom: {
        team: record.entity,
      },
      name:
        record.entity.id === NO_TEAM_ID ? intl.formatMessage(messages.noTeam) : record.entity.name,
      sliced: selectedTeamIds.has(record.entity.id),
      y:
        dataMode === DataViewMode.AVG && teamCount[record.entity.id]
          ? record.value / teamCount[record.entity.id]
          : record.value,
    }));
  }, [dataMode, intl, selectedTeamIds, userData]);

export default useTeamChartData;
